import React, { FC, ReactNode, RefObject, useRef } from 'react';
import { styled } from 'linaria/react';
import { useWindowScrollPosition } from '@shared/lib/browser';
import { withTheme } from '@shared/lib/theme';
import { usePartner } from '@shared/lib/partner';
import { ModalProps } from '@shared/ui/organisms';
import DesktopNavbarButton from './DesktopNavbarButton';
import SearchButton from './SearchButton';
import { useActiveNavbarElement } from '../lib/useActiveNavbarElement';
import { getDesktopNavbarItemsByPartner } from '../config/navbarItems';
interface SuggestModalProps extends ModalProps {
  navbarRef: RefObject<HTMLElement>;
}
interface NavbarProps {
  renderSearchModal: (props: SuggestModalProps) => ReactNode;
}
const DesktopNavbar: FC<NavbarProps> = ({
  renderSearchModal
}) => {
  const isAtTop = useWindowScrollPosition();
  const {
    partner
  } = usePartner();
  const activeNavbarElement = useActiveNavbarElement();
  const navbarRef = useRef<HTMLElement>(null);
  return <NavbarWrapper ref={navbarRef} isAtTop={isAtTop}>
      <NavButtonsWrapper isAtTop={isAtTop}>
        {getDesktopNavbarItemsByPartner(partner).map(item => <DesktopNavbarButton key={item.label} isAtTop={isAtTop} isActive={item.label === activeNavbarElement?.label} item={item} />)}
      </NavButtonsWrapper>
      <SearchButton navbarRef={navbarRef} isAtTop={isAtTop} renderSearchModal={renderSearchModal} />
    </NavbarWrapper>;
};
export default DesktopNavbar;
interface NavbarWrapperProps {
  isAtTop: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '4rem' : '3rem';
const _exp2 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '0' : '0.5rem';
const _exp3 = /*#__PURE__*/() => ({
  isAtTop,
  theme
}) => isAtTop ? theme.colors.background.hover : 'transparent';
const _exp4 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? 'blur(1rem)' : 'none';
const NavbarWrapper = withTheme(/*#__PURE__*/styled('nav')({
  name: "NavbarWrapper",
  class: "nkg1n68",
  propsAsIs: false,
  vars: {
    "nkg1n68-0": [_exp()],
    "nkg1n68-1": [_exp2()],
    "nkg1n68-2": [_exp3()],
    "nkg1n68-3": [_exp4()]
  }
}));
interface NavButtonsWrapperProps {
  isAtTop: boolean;
}
const _exp5 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '1.25rem' : '0.5rem';
const _exp6 = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '0px 1.25rem 0px 0.5rem' : '0.5rem 1.25rem 0.5rem 0.5rem';
const NavButtonsWrapper = /*#__PURE__*/styled('ul')({
  name: "NavButtonsWrapper",
  class: "nw3091j",
  propsAsIs: false,
  vars: {
    "nw3091j-0": [_exp5()],
    "nw3091j-1": [_exp6()]
  }
});

require("./DesktopNavbar.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DesktopNavbar.tsx");